import { Script } from 'gatsby';
import React, { use } from 'react';

import { SiteContext } from 'src/context/site-context';
import { BuildDomain, getBuildDomainForBuildType } from 'src/enums/build/build-domain';

export const getAmplitudeKey = (buildDomain: BuildDomain) =>
  buildDomain === BuildDomain.TOGETHER_FOUNDATION
    ? process.env.GATSBY_TOGETHER_FOUNDATION_AMPLITUDE_API_KEY
    : process.env.GATSBY_AMPLITUDE_API_KEY;

/**
 * The initialisation script for Amplitude is defined elsewhere.
 * @see onClientEntry
 */
const Amplitude: React.FC = () => {
  const { buildType } = use(SiteContext);

  const amplitudeKey = getAmplitudeKey(getBuildDomainForBuildType(buildType));

  return (
    <>
      <link rel="dns-prefetch" href="https://sr-client-cfg.eu.amplitude.com" />
      <link rel="preconnect" href="https://cdn.eu.amplitude.com" />
      {amplitudeKey && (
        <Script
          id="amplitude-experimental-inline-script"
          type="text/javascript"
          strategy="post-hydrate"
        >
          {`(function(w,d,s,i){var f=d.getElementsByTagName(s)[0],` +
            `j=d.createElement(s);j.async=true;j.src=` +
            `'https://cdn.eu.amplitude.com/script/'+i+'.experiment.js';f.parentNode.insertBefore(j,f);` +
            `})(window,document,'script','${amplitudeKey}');`}
        </Script>
      )}
    </>
  );
};

export default Amplitude;
